/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './resolveLexicon.defs.js'
export * as $defs from './resolveLexicon.defs.js'
